import React, {Component} from 'react'
import {Input} from 'reactstrap'
import {AvForm, AvInput} from 'availity-reactstrap-validation'
import PropTypes from 'prop-types'
import LoadingButton from "../LoadingButton";

export default class ClientContactInput extends Component {

    onChange = (data => {
        this.props.onChange({...data})
    })

    render() {

        const {
            first_name,
            last_name,
            position,
        } = this.props

        const {onSave, onCancel, loading} = this.props

        const {onChange} = this

        return (
            <AvForm
                className="d-flex flex-row pt-2 pb-2"
                onValidSubmit={() => {
                    onSave()
                }}
            >
                <div className="d-flex mr-2" style={{flex: '1'}}>
                    <AvInput
                        required
                        name="first_name"
                        size="sm"
                        placeholder="First Name*"
                        value={first_name}
                        onChange={(evt) => onChange({key: 'first_name', value: evt.target.value})}
                    />
                </div>
                <div className="d-flex mr-2" style={{flex: '1'}}>
                    <AvInput
                        required
                        name="last_name"
                        size="sm"
                        placeholder="Last Name*"
                        value={last_name}
                        onChange={(evt) => onChange({key: 'last_name', value: evt.target.value})}
                    />
                </div>
                <div className="d-flex mr-2" style={{flex: '1'}}>
                    <Input
                        size="sm"
                        placeholder="Position"
                        value={position}
                        onChange={(evt) => onChange({key: 'position', value: evt.target.value})}
                    />
                </div>
                <LoadingButton
                    icon="times"
                    loading={false}
                    size="sm"
                    onClick={onCancel}
                    className="mr-1"
                />
                <LoadingButton
                    icon="save"
                    loading={loading}
                    size="sm"
                    color="success"
                />
            </AvForm>

        )
    }

}

ClientContactInput.propTypes = {
    onSave: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    position: PropTypes.string,
}